import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Rubro } from "@/shared/types/rubro";

export async function getRubro(id: string): Promise<Rubro> {
    await sleep(1000);
    const response = await api.get("rubros/" + id);
    return response.data;
}

export function useGetRubroQuery(id: string, queryConfig: QueryConfig<Rubro> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getRubro(id),
        queryKey: ["rubros", id],
    })
}

export interface GetRubroQueryProps {
    id: string,
    queryConfig?: QueryConfig<Rubro>,
    children?: (queryResult: QueryResult<Rubro>) => ReactNode
}

export function GetRubroQuery({
    id,
    children,
    queryConfig
}: GetRubroQueryProps) {
    const queryResult = useGetRubroQuery(id, queryConfig);
    return children && children(queryResult);
}